import { render } from "./stackProvinceHor.vue?vue&type=template&id=0b7e2762&scoped=true"
import script from "./stackProvinceHor.vue?vue&type=script&lang=js"
export * from "./stackProvinceHor.vue?vue&type=script&lang=js"

import "./stackProvinceHor.vue?vue&type=style&index=0&id=0b7e2762&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7e2762"]])

export default __exports__